import { jsx as _jsx } from "react/jsx-runtime";
import MuiSwitch from '@mui/material/Switch';
import { useResponsiveSize } from '@famly/mf_util_breakpoints';
export const ToggleControl = ({ checked, disabled, id, inputProps, onChange, size: sizeFromProps, ...dataProps }) => {
    const size = useResponsiveSize(sizeFromProps);
    const handleChange = (_event, isChecked) => {
        onChange(isChecked);
    };
    return (_jsx(MuiSwitch, { checked: checked, disabled: disabled, disableRipple: true, id: id, inputProps: inputProps, onChange: handleChange, size: size === 'compact' ? 'small' : 'medium', ...dataProps }));
};
